import React from 'react';
import { motion } from 'framer-motion';
import { CrosshairIcon } from 'lucide-react';
export function Navbar() {
  return <motion.nav initial={{
    y: -100,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="fixed top-0 left-0 right-0 z-50 glass-panel border-x-0 border-t-0 rounded-none" data-id="element-161">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <div className="flex items-center justify-between h-20" data-id="element-163">
          <div className="flex items-center gap-3" data-id="element-164">
            <CrosshairIcon className="w-8 h-8 text-primary" data-id="element-165" />
            <span className="font-display font-extrabold text-xl tracking-wider text-white" data-id="element-166">
              SNIPER <span className="text-primary" data-id="element-167">PANEL</span>
            </span>
          </div>

          <div className="hidden md:block" data-id="element-168">
            <a href="#offer" className="inline-flex items-center justify-center px-6 py-2.5 border border-primary bg-primary/10 text-primary font-medium text-sm rounded-sm hover:bg-primary hover:text-dark transition-all duration-300 box-glow font-display tracking-wide uppercase" data-id="element-169">
              Obtener Acceso
            </a>
          </div>
        </div>
      </div>
    </motion.nav>;
}